export function generatoreCode(n):string {
  var T = [];
  var pop = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

  for (var i = 0; i < n; i++)
    T.push(pop.charAt(Math.floor(Math.random() * pop.length)));

  return T.join('');
}
